import { encryptStorage } from 'src/Util'
import { authAPI, usersAPI } from '../api'
//import { authAPI, usersAPI } from '../apiLocal'
 
//Action Types
//export const LOGIN_INIT = 'LOGIN_INIT'
export const LOGIN_USER_DETAILS = 'LOGIN_USER_DETAILS'
export const LOGIN_USER_DETAILS_SUCCESS = 'LOGIN_USER_DETAILS_SUCCESS'
export const LOGIN_USER_DETAILS_ERROR = 'LOGIN_USER_DETAILS_ERROR'

export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS'
export const PASSWORD_RESET_ERROR = 'PASSWORD_RESET_ERROR'

export const LINK_DETAILS_SUCCESS = 'LINK_DETAILS_SUCCESS'
export const PASSWORD_CREATE_SUCCESS = 'PASSWORD_CREATE_SUCCESS'

export const LOGOUT_USER = 'LOGOUT_USER'
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS'
export const DESTROY_SESSION ="DESTROY_SESSION"

//Action Creators
export const loginDetail = (email, password) => (dispatch) => {
  const userDetails = {
    email_id: `${email}`,
    password: `${password}`,
  }
  authAPI.post('/login', userDetails).then((loginres) => {
    if (loginres.data.status === 'success') {
      encryptStorage.setItem('session-auth', true)
      encryptStorage.setItem('session-user', JSON.stringify(loginres.data))
      dispatch({
        type: LOGIN_USER_DETAILS_SUCCESS,
        payload: loginres.data,
      })
    } else
      dispatch({
        type: LOGIN_USER_DETAILS_ERROR,
        payload: loginres.data,
      })
  })
}

export const resetPassword = (email) => (dispatch) => {
  const userDetails = {
    email_id: `${email}`,
  }
  usersAPI.post('/user/forgotpassword/', userDetails).then((loginres) => {
    dispatch({
      type: PASSWORD_RESET_SUCCESS,
      payload: loginres.data,
    })
  })
}

export const createPassword = (userdetail) => (dispatch) => {
  console.log('Create PAssword ::', userdetail)
  usersAPI.post('/user/updatepassword/', userdetail).then((loginres) => {
    dispatch({
      type: PASSWORD_CREATE_SUCCESS,
      payload: loginres.data,
    })
  })
}

export const getPasswordLinkDetails = (link,type) => (dispatch) => {
  usersAPI.get(`/user/${type==="create"?'userinvitation':'forgetinvitation'}?link=${link}`).then((loginres) => {
    dispatch({
      type: LINK_DETAILS_SUCCESS,
      payload: loginres.data,
    })
  })
}

export const resetLogin = () => (dispatch) => {
  localStorage.removeItem('session-auth')
  localStorage.removeItem('session-user')
  // localStorage.clear()
  //window.location.href="/#/logout";
  dispatch({ type: DESTROY_SESSION });
  // dispatch({
  //   type: LOGOUT_USER,
  // })
}
